import { createContext } from 'react'

export const initialModalState = false

export const TweetModalContext = createContext(initialModalState)
